export const fonts = {
	fontFamily: 'Gotham',
	fontFamilyTitle: 'Gotham',
}
